export default "__VITE_ASSET__DbRUK$7v__"